import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nfilter'
})
export class NfilterPipe implements PipeTransform {

  transform(items: any[], term: any): any[] {
    if(!items) return [];
    if(!term) return items;
    term = term.toString().toLowerCase();
    return items.filter( it => {
      return it.title.toString().toLowerCase().includes(term);
    });
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/nfilter.pipe.ts